import config from 'constants/config'

import pins from './PropertyMarker/pins'

interface MarkerPinAsset {
  normal: string
  active: string
  imageId: string
}

const brandedPins: Record<string, Partial<Record<string, MarkerPinAsset>>> = {
  luxuryescapes: {
    property: pins.luxuryescapes,
    nearby: pins.luxuryescapes,
    moments: pins.moments,
    'see-and-do': pins['see-and-do'],
    'eat-and-drink': pins['eat-and-drink'],
    'cruise-pill': pins['cruise-pill'],
    'cruise-pill-icon': pins['cruise-pill-icon'],
  },
  scoopontravel: {
    property: pins.scoopontravel,
    nearby: pins.scoopontravel,
  },
}

export function getMarkerPin(markerType: App.MapMarker['type'], brand: string = config.BRAND): MarkerPinAsset {
  const brandedPin = brandedPins[brand]
  return brandedPin?.[markerType] ?? pins.default
}

export function getMarkerImage(marker: Pick<App.MapMarker, 'type'>, active: boolean, brand: string = config.BRAND) {
  const pin = getMarkerPin(marker.type, brand)
  return active ? pin.active : pin.normal
}
